import React from 'react';
import { connect } from 'react-redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Row, Col } from 'react-bootstrap';
import { loadFinTab } from '../store/finTab.store';
import './fintab.less';
import { PdfExportButton, XlsExportButton } from '@/component/blogic/reports/OpenPosition';

class FinanceTabContainer extends React.PureComponent {
  componentWillMount() {
    this.props.loadFinTab();
  }
  trClassFormat = (row) => (row.highlight ? 'fin-table-highlight' : '');


  render() {
    let saleIdx = 1;
    return (<div className="purchase-fin-table">
      <Row>
        <XlsExportButton
          onClick={(e) => {
            e.stopPropagation();
            window.location = `/api/report/export/purchase/finance/${
              this.props.dealId}?format=xlsx`;
          }}
        />
        <PdfExportButton
          onClick={(e) => {
            e.stopPropagation();
            window.location = `/api/report/export/purchase/finance/${this.props.dealId}?format=pdf`;
          }}
        />
      </Row>
      {!this.props.data ? 'Loading...' : this.props.data.map((e, idx) =>
        <div key={idx}>
          {e.get('purchase') && <Row>
            <br />
            {idx ? <br /> : ''}
            <Col lg={6} md={12} >
              <Row>
                <BootstrapTable data={e.get('purchase').toJS()} trClassName={this.trClassFormat}>
                  <TableHeaderColumn dataField="name" isKey>Purchase Details</TableHeaderColumn>
                  <TableHeaderColumn dataField="value" />
                </BootstrapTable>
              </Row>
            </Col>
          </Row>
          }
          {e.get('sale') && <Row>
            <br />
            <Col lg={6} md={12} >
              <Row>
                <BootstrapTable data={e.get('sale').toJS()} trClassName={this.trClassFormat}>
                  <TableHeaderColumn dataField="name" isKey>
                    {`Sale ${saleIdx++} Details`}
                  </TableHeaderColumn>
                  <TableHeaderColumn dataField="value" />
                </BootstrapTable>
              </Row>
            </Col>
          </Row>
          }
        </div>
      )}

    </div>);
  }
}

export default connect(
  state => ({
    data: state.getIn(['data', 'deals', 'fintab']),
    dealId: state.getIn(['data', 'deals', 'deal', 'id']),
  }),
  (dispatch, props) => ({
    loadFinTab() {
      loadFinTab(dispatch, props.dealId);
    },
  })
)(FinanceTabContainer);
